import BaseTrack from "./basetracks";

import {fromTimeToPixel, fromPixelToTime} from "../../../../../utils/timelineutils.js"


class SequencesTrack extends BaseTrack
{
    constructor (type, datas, file1, file2, channel, id, parent)
    {
        super (type, datas, file1, file2, channel, id, parent);
    
        var style = getComputedStyle(document.body);
        this.backcolor = style.getPropertyValue('--timeline-transcripttrack-backcolor');        

        
        this.defaultHeight = 25;
        this.minHeight = 25;
        this.maxHeight = 40;
        this.height = this.defaultHeight;
        
        this.ontopmost = false;
        this.ontop = true;
        this.onbottom = false;
        this.onbottommost = false;
        

    }


    isFixedHeight()
    {
        return false;
    }

    canExtend(sequenceId, maxtime)
    {
        
        const nbsquences = this.datas.sequences.length;
        if (sequenceId !== (nbsquences-1)) return false;
        const tcout = this.datas.sequences[sequenceId].out;
        console.log(sequenceId, tcout, maxtime)
        return tcout < maxtime;


    }
    canSetTcOut(sequenceId, time)
    {
        const nbsquences = this.datas.sequences.length;
        if (sequenceId >= (nbsquences-1)) return false;
        const tcin = this.datas.sequences[sequenceId].in;
        const tcout = this.datas.sequences[sequenceId].out;

        const tcinnext = this.datas.sequences[sequenceId+1].in;
        const tcoutnext = this.datas.sequences[sequenceId+1].out;

        if (time < tcin + 1) return false; // pas de séquence de moins d'une seconde
        if (time < tcout) return true;

        // on regarde si on peut raccourcir la séquence suivante
        if (time > tcoutnext) return false;
        if ((tcoutnext - time) >= 1) return true;
        return false;

    }



    canSetTcIn(sequenceId, time)
    {
        const nbsquences = this.datas.sequences.length;
        if (sequenceId <= 0 || sequenceId >= nbsquences) return false;
        const tcin = this.datas.sequences[sequenceId].in;
        const tcout = this.datas.sequences[sequenceId].out;

        const tcinprevious = this.datas.sequences[sequenceId-1].in;
        const tcoutprevious = this.datas.sequences[sequenceId-1].out;

        if (time >= tcout - 1) return false; // pas de séquence de moins d'une seconde
        if (time >= tcin) return true;

        // on regarde si on peut raccourcir la séquence précédente
        if (time <= tcinprevious) return false;
        if ((time - tcinprevious) >= 1) return true;
        return false;

    }

    canCreateSequence (sequenceId, time)
    {
        const nbsquences = this.datas.sequences.length;
        if (sequenceId < 0 || sequenceId >= nbsquences) return false;
        const tcin = this.datas.sequences[sequenceId].in;
        const tcout = this.datas.sequences[sequenceId].out;
        if ((time-tcin) < 1) return false;
        if ((tcout-time) < 1) return false;
        return true;
    }

    canDeleteWithPrevious (sequenceId)
    {
        const nbsquences = this.datas.sequences.length;
        if (nbsquences === 0 || sequenceId === 0) return false;
        return true;
    }
    
    canDeleteWithNext (sequenceId)
    {
        const nbsquences = this.datas.sequences.length;
        if (sequenceId >= (this.datas.sequences.length -1)) return false;
        return true;
    }
    setNewDatas(datas, id, extendeddatas)
    {
        super.setNewDatas(datas,id)
        this.id = extendeddatas.asid;
    }

    getMouseDown(time)
    {
        const nbsquences = this.datas.sequences.length;
        var retsequencenumber = -1;
        var retsequence = null;
        for (var i=0; (i <nbsquences) && (retsequencenumber===-1); i++ )
        {
            if ((time >= this.datas.sequences[i].in) && (time <= this.datas.sequences[i].out))
            {
                retsequencenumber = i;
                retsequence = this.datas.sequences[i];

            }
        }
        return {sequenceId: retsequencenumber, sequence: retsequence};
    }


    redrawbackgroundLevel1(context, width, currentTime, sTimeCode, starttime, duration,fullheight, yStart)
    {
        // this.datas = sequences
        // this.file1 = asset
        if (width <=0) return;
        super.redrawForeGround(context,width);

        starttime = starttime + this.parent.offsetTime();

        var startdrawtime = Math.floor(starttime) -1;
        if (startdrawtime< 0) startdrawtime = 0;
        var enddrawtime = startdrawtime + duration+2;

        var cont = true;
        var ind = 0;



        while (cont)
        {
            if (ind >= this.datas.sequences.length)
                cont = false;
            else
            {
                if (this.datas.sequences[ind].out < startdrawtime)
                    cont = true;
                else
                {
                    if (this.datas.sequences[ind].in > enddrawtime)
                        cont = false;
                    else
                    {
                        var xpos = fromTimeToPixel(this.datas.sequences[ind].in, width, starttime, duration);
                        if (xpos < 0) xpos = 0;
                        var xposfin = fromTimeToPixel(this.datas.sequences[ind].out, width, starttime, duration);
                        if (xposfin > width) xposfin = width;

                        const largeur = xposfin - xpos;


                        if (largeur > 0)
                        {
                            context.save();
                            context.beginPath();
                            context.rect (xpos, this.baseline,
                                largeur, this.height);

                            context.clip();

                            context.fillStyle = (ind & 1)?"#0F172A":"#1E293B";

                            if (this.datas.sequences[ind].status === "Empty") context.fillStyle = "black";
                            
                            context.fillRect(xpos, this.baseline, largeur,this.height);
                            

                            if (largeur > 60)
                            {

                                this.drawRoundedRect(
                                    context, 
                                    xpos+6,this.baseline+2,
                                    50,this.height-6,
                                    {fillStyle:"#303030", radius:3, strokeStyle:"white"}

                                )
                                var fs = this.height - 5;
                                if (fs > 3)
                                {
                                    context.fillStyle = "#FFFFFF";
                                    context.textBaseline = 'bottom';
                                    context.font = fs.toString()+"px Arial";

                                    const sind = (ind+1).toString();
                                    const w = context.measureText(sind).width;
                                    context.fillText(sind,xpos+31 - w/2,this.baseline + this.height -2);
                                    context.fillText(this.datas.sequences[ind].title,xpos + 60,this.baseline + this.height - 2);
                                }

                            }

                            context.restore();
                        }

                        


                        // on dessine le numéro de séquence
                        var xstart = xpos; if (xstart < 0) xstart=0;
                        





                        

                    }
                }
            }
            ind++;
        }


    }
   
}

export default SequencesTrack;